// PageSrTitle — the page title of a surface that shows none.
//
// One title per host (workspace design-direction.md §3). Most pages print
// their title and that title is the `h1`. A few surfaces open straight on
// their content by design — the home board, mail, the marketplace browse view
// (its hero was removed on purpose, 2026-09-03), the agents board — so their
// dedicated URL had NO `h1` and a screen reader landed on a page with no name
// (live walk 2026-09-21). The design does not change: the page mounts
// `PageSrTitle: { text: '{{ key | polyglot }}' }` and gains a heading that is
// announced and never seen.
//
// VISUALLY hidden, never `display: none` / `visibility` / `opacity`: those
// remove the node from the accessibility tree, the one place it must be. The
// 1px clip box is the sr-only idiom the framework's own Checkbox states as the
// single raw-px exception. An absolutely positioned child takes no flex item
// and no grid cell, so mounting it moves nothing.
//
// Under a PageSlot pane bar the bar is already the `h1` and already names the
// page, so this one leaves the tree there (`hide` does mean display:none).
export const PageSrTitle = {
  tag: 'h1',
  hide: (el, s) => el.call('paneTitleBarShown', s),
  position: 'absolute',
  width: '1px',
  height: '1px',
  margin: '-1px',
  padding: '0',
  border: '0',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap'
}
